export default function () {
  function setCurrency(code) {
    $('.currency').val(code);
    $('.currency-icon')
      .removeClass(`fa-gbp fa-usd`)
      .addClass(`fa-${code.toLowerCase()}`);
  }

  function detectCurrency() {
    var currency = $('#payment_currency input:checked').val();
    if (currency) {
      return currency;
    }

    return 'USD';
  }

  $('#payment_currency input').change(function() {
    setCurrency($('#payment_currency input:checked').val());
  });

  var initialCurrency = detectCurrency();
  setCurrency(initialCurrency);
  var code = $(`#payment_currency input[value=${initialCurrency}]`).prop('checked', true);

  $('#payment_account').change(function() {
    var accountId = $(this).val();
    var balance = 'Unknown';
    if (window.balances[accountId]) {
      balance = window.balances[accountId].amount / 100;

      var amountInput = $('#payment_amount_amount');
      if (!amountInput.val() || amountInput.val() == '0') {
        amountInput.val(balance);
      }
      balance = '$' + balance.toLocaleString('en');
    }
    $('.account-balance').text(balance);
  });
  $('#payment_account').change();
};



// WEBPACK FOOTER //
// ./assets/js/create-payment.js